import '../components/Tab.css';
import Box from '../components/Box';
import Tab from '../components/Tab';
import Text from '../components/Text';
import { translate } from '../locale';
import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import useCourses from '../hooks/useCourses';
import { useBooking } from '../BookingProvider';
import { useHistory, useQuery } from '../hooks/useParams';
import FullPageSpinner from '../components/FullPageSpinner';
import CourseListViewItem from '../components/CourseListViewItem';

export default function PgsPage() {
  let { part: partQueryValue } = useQuery();
  const history = useHistory();
  const { addCourse, locale, org } = useBooking();

  const part = useMemo(() => {
    return partQueryValue ? parseInt(partQueryValue, 10) : 1
  }, [partQueryValue]);

  const [isLoadingCourses, courses] = useCourses("PGS", { organizationName: org ? org : undefined });

  const memoizedCourses = useMemo(() => {
    if (!courses) return [];

    const array = [] as any;
    for (const course of courses) {
      if (course.part === 2 || course.part === 4) {
        const part1Course = courses.find((x) => x.part === 1 && x.groupId === course.groupId);
        if (part1Course) {
          Object.assign(part1Course, {
            [course.part === 2 ? 'dateRange2' : 'dateRange3']: {
              start1: course.start1,
              end1: course.end1
            }
          });
        }

        continue;
      }

      if (course.part !== 1) continue;

      Object.assign(course, {
        dateRange1: {
          start1: course.start1,
          end1: course.end1
        }
      });

      array.push(course);
    }

    return array;
  }, [courses, part]);

  if (isLoadingCourses) return <FullPageSpinner />
  if (!memoizedCourses) return null;

  return (
    <Box>
      <Box
        direction='column'
        paddingHorizontal={16}
        paddingVertical={8}
        style={{
          overflow: "auto",
          fontSize: 15
        }}
      >
        <Text>
          <b>{translate(locale, 'pgsPrice', 'label')}</b>
        </Text>
        <Text>
          <b>{translate(locale, 'pgsPrice', 'price')}</b> ({translate(locale, 'pgsPrice', 'note1')}) / <b>{translate(locale, 'pgsPrice', 'price')}</b> ({translate(locale, 'pgsPrice', 'note2')}) / <b>{translate(locale, 'pgsPrice', 'price')}</b> ({translate(locale, 'pgsPrice', 'note3')})
        </Text>
      </Box>
      <Box divider alignItems='center' direction='row' cursor='pointer' className='Tabs'>
        <Link to='?part=1'>
          <Tab selected={part === 1} label='Grundkurs 1-3' />
        </Link>

        <Link to='?part=2'>
          <Tab selected={part === 2} label='Im Besitz Kat. A1' />
        </Link>
      </Box>
      <Box>
        {
          part !== 2 ?
            memoizedCourses.map((course) => <CourseListViewItem key={course._id} course={course} onClick={() => {
              if (course.freePlaces === 0) return;

              addCourse(course);
              history.push('/pgs/booking');
            }} />) :
            <Box padding={16}>
              <Text><div dangerouslySetInnerHTML={{ __html: translate(locale, 'infoMessage', org ? org === 'fahrschulemoos' ? 'pgsPart2and3Moos' : 'pgsPart2and3Sven' : 'pgsPart2and3') }}></div></Text>
            </Box>
        }
      </Box>
    </Box>
  );
}
